<template>
  <div class="proposal">
    <c-head-proposal></c-head-proposal>
    <div class="proposalContent">
      <h3>抵制网络谣言倡议书</h3>
      <div class="text">
        网络谣言不仅扰乱人们的生活，引发社会震荡，更危害公众利益，损害政府形象，对社会稳定造成严重危害。
      </div>
      <div class="text">
        为营造风清气朗的网络环境，倡议全体网民共同抵制网络谣言。
      </div>
      <div class="text">
        <span class="textNum">1.</span> 不在互联网发布没有事实根据的谎言；
      </div>
      <div class="text">
        <span class="textNum">2. </span>
        不在互联网谎报险情、疫情、警情，或曲解、夸大险情、疫情、警情；
      </div>
      <div class="text">
        <span class="textNum">3. </span>
        不在互联网虚构恐怖信息或危害公众安全事件信息；
      </div>
      <div class="text">
        <span class="textNum">4. </span>
        不针对个人而编造吸引眼球的虚假信息，侵害当事人隐私。
      </div>

      <div class="text">
        净化网络环境，打击网络谣言，需要广大网民共同努力。希望广大网民保持理性思考，提高防范意识，积极抵制网络谣言，做到不信谣、不传谣、不造谣，携手共建清朗网络家园。
      </div>
    </div>
    <c-foot></c-foot>
  </div>
</template>

<script>
import CHeadProposal from "@components/public/c-header-proposal";
import CFoot from "@components/public/c-foot";
export default {
  name: "proposal",
  components: {
    CHeadProposal,
    CFoot,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.proposal {
  // padding: 30px 26% 0;
  background-color: #f7f7f7;
  .proposalContent {
    font-family: STFangsong;
    color: #333;
    padding: 120px 121px 160px;
    line-height: 50px;
    background-color: #fff;
    border: 1px solid #d6d2d2;
    font-size: 24px;
  }
  h3 {
    font-family: STSong;
    text-align: center;
    color: #000;
  }
  .text {
    text-indent: 48px;
  }
  .textNum {
    margin-right: 5px;
  }
}
</style>
